import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import DocumentoComissaoController from "@/shared/controllers/documentoComissao/documentoComissaoController";
import EVENTS from "@/shared/events/events";
import FiltroDocumentoComissao from "@/shared/view-models/Filtros/FiltroDocumentoComissao";
import { defineComponent } from "vue";
import AccountLoged from "@/shared/mixins/AccountLoged";


const name = 'Comissoes'


export default defineComponent({
    name,

    components:{
        "g-button": gButton,
        "g-card": gCard,
    },

    props: { },
    mixins:[AccountLoged],

    mounted() {
        if(!this.hasClaim('Consultas-Consulta de Comissões')) {
            this.$router.push('/sem-acesso')
          }
        this.popularDropDownEmpresa();
        DocumentoComissaoController.GetDocumentoComissaoTipoEnum().requisicao
        .then(res => {
            let array = [];
            array.push({
                text: 'TODOS',
                value: null
            })
            this.tipoArray = array.concat(res.data.data);

        });
        this.atualizaRepresentante();
        this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
            this.atualizaRepresentante()
        })
    },

    updated() { },

    data() {
        return {
            grid: true,
            EmpresaArray: [],
            tipoArray: [],
            filialArray: [],
            ValoresTotalGeral: null,
            objFiltros: new FiltroDocumentoComissao(),
            documentoComissoesArray: [],
            tipoOrdenacao: [
                {
                    value: 0,
                    text: 'Título'
                },
                {
                    value: 1,
                    text: 'Recebimento'
                }
            ],
            Colunas: [
                {
                    field: 'numeroDocumento',
                    header: 'Documento',
                    width: '16%',
                    ordena: true,
                },
                {
                    field: 'nomeCliente',
                    header: 'Cliente',
                    width: '16%',
                    ordena: true,
                },
                {
                    field: 'curvaCliente',
                    header: 'CV',
                    width: '16%',
                    ordena: true,
                    alinha: 'center'
                },
                {
                    field: 'dataRegistroFormatada',
                    header: 'Data',
                    ordena: true,
                    width: '16%',
                    ordenacao: 'dataRegistro'
                },
                {
                    field: 'valorTituloFormatado',
                    header: 'Vlr. Título',
                    width: '16%',
                    ordena: true,
                    alinha: 'right'
                },
                {
                    field: 'comissaoFormatada',
                    header: 'Comissão',
                    width: '16%',
                    ordena: true,
                    alinha: 'right'
                },

            ]
        }
    },

    methods: {
        buscar() {
            this.$isLoading(true)


        
            DocumentoComissaoController.GetDocumentoComissaoByFiltro(this.objFiltros).requisicao
            .then(res => {
                this.documentoComissoesArray = res.data.data.comissoes;
                this.ValoresTotalGeral = res.data.data
                this.grid = false
            }).finally(() => {
                this.$isLoading(false)
            })
        },

        popularDropDownEmpresa(){
            this.EmpresaArray = this.$store.state.EmpresaArray;
        },

        limpar(){
            this.objFiltros = new FiltroDocumentoComissao();
            this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
        },

        atualizaRepresentante(){
            this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
        },
    },

    computed: { }
});